import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

const SignatureField = ({
  label,
  name,
  onChangeHandler,
  required,
  value = "",
  isValid = true,
  errorMessage = "",
}) => {
  const sigCanvas = useRef(null);
  const inputRef = useRef(null);

  const updateSignatureValue = () => {
    if (!inputRef.current || !sigCanvas.current) {
      return;
    }

    const nextValue = sigCanvas.current.isEmpty()
      ? ""
      : sigCanvas.current.toDataURL();

    inputRef.current.value = nextValue;

    if (onChangeHandler) {
      onChangeHandler({
        target: {
          name,
          value: nextValue,
        },
      });
    }
  };

  const clearSignature = () => {
    if (!sigCanvas.current) {
      return;
    }

    sigCanvas.current.clear();
    updateSignatureValue();
  };

  return (
    <>
      <div className="tps-form-question">
        <div className="tps-form-label">
          <label
            className={`EditingFormLabel ${
              required
                ? "tps-field-required tps-to-validate"
                : "tps-not-required"
            }`}
          >
            {label}
          </label>
        </div>
        <div className="tps-form-input">
          <div className="EditingFormControlNestedControl editing-form-control-nested-control">
            <div className="tps-canvas-input-wrapper">
              <input
                ref={inputRef}
                name={name}
                type="text"
                className="tps-canvas-input form-control tps-to-validate"
                value={value}
                onChange={(event) => onChangeHandler?.(event)}
              />
              <div
                style={{ position: "relative", width: "fit-content" }}
                className={`${!isValid ? "Error" : ""}`}
              >
                <SignatureCanvas
                  ref={sigCanvas}
                  onEnd={updateSignatureValue}
                  canvasProps={{
                    className: `tps-canvas-input-inner`,
                  }}
                />

                <a
                  onClick={clearSignature}
                  style={{
                    color: "#191919",
                    position: "absolute",
                    top: ".625rem",
                    right: ".625rem",
                  }}
                >
                  <span>Reset</span>
                  <i className="fal fa-redo" aria-hidden="true"></i>
                </a>
              </div>
            </div>

            {!isValid && (
              <label
                className={`fatv2-body form-control tps-field-required EditingFormErrorLabel`}
                htmlFor={errorMessage}
              >
                {errorMessage}
              </label>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SignatureField;
